import { css } from "@emotion/css";
import styled from "@emotion/styled";
import {
    BorderRadius,
    Colors,
    FontSizeInPx,
    FontWeight,
    Fonts,
    LineHeightInPx,
    ShadowValue,
    Spacing,
} from "@snapchat/snap-design-system";
// eslint-disable-next-line no-restricted-imports -- SDS needs to export Durations from their root barrel
import { Durations } from "@snapchat/snap-design-system/es/constants";

import { appearingAnimation } from "../../../shared/styles";

export const sidebarContent = css`
    padding: ${Spacing.MD}px ${Spacing.LG}px;

    background: ${Colors.WHITE};
    border-radius: ${BorderRadius.container}px;
    box-shadow: ${ShadowValue.regular};

    animation: ${appearingAnimation} ${Durations.STANDARD} ease;
`;

export const SidebarPanelStyle = css`
    ${Fonts.Paragraph.P300};

    &:not(:last-child) {
        padding-bottom: ${Spacing.MD}px;
    }
`;

export const SectionSeparator = styled.hr`
    height: 1px;
    margin: 0 0 ${Spacing.MD}px;
    background: ${Colors.Gray.V100};
    border: 0;
`;

export const sectionLabel = css`
    margin-bottom: ${Spacing["2XS"]}px;
`;

export const TextContainer = styled.div`
    padding: 0 0 0 ${Spacing.MD}px;
`;

export const SidebarPanelText = styled.p`
    padding-bottom: ${Spacing.MD}px;
`;

export const SidebarModalHeading = styled.h3`
    padding-bottom: ${Spacing.SM}px;

    font-size: 16px;
    font-weight: ${FontWeight.MEDIUM};
    line-height: 20px;
    color: ${Colors.Black.V200};
`;

export const SidebarModalInfo = styled.p`
    padding-bottom: 19px;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: ${LineHeightInPx.REGULAR}px;
    color: #16191c;
    letter-spacing: 0.2px;

    > span > .sds-base-button.ant-btn {
        font-size: ${FontSizeInPx.REGULAR}px;
    }
`;
